

import { useState } from "react";
import { Box, Button, } from "@mui/material";

import Used from "./Used";
import Unused from "./Unused";
import Requests from "./requests";

export default function GiftCardUser() {
    const [activeTab, setActiveTab] = useState("Used");
    return (
        <>
            <Box>
                <Box display="flex" justifyContent="center" gap={2} mb={2}>
                    <Button
                        variant={
                            activeTab === "Used"
                                ? "contained"
                                : "outlined"
                        }
                        onClick={() => setActiveTab("Used")}
                    >
                        Used
                    </Button>
                    <Button
                        variant={
                            activeTab === "UnUsed" ? "contained" : "outlined"
                        }
                        onClick={() => setActiveTab("UnUsed")}
                    >
                        UnUsed
                    </Button>
                    <Button
                        variant={
                            activeTab === "requests" ? "contained" : "outlined"
                        }
                        onClick={() => setActiveTab("requests")}
                    >
                        requests
                    </Button>
                   
                </Box>

                {activeTab === "Used" && (
                    <Used />
                )}
                {activeTab === "UnUsed" && (
                    <Unused />
                )}
                {activeTab === "requests" && (
                    <Requests />
                )}
               
            </Box>


        </>
    );
}
